module.exports = "<div *ngFor=\"let item of blogItems\">\n    <h3><a href=\"#\" (click)=\"showItem($event, item.postSlug)\">{{item.postTitle}}</a></h3>\n    <p>Posted on {{item.postDate | date}}</p>\n    <p [innerHtml]=\"item.postDesc\"></p>\n    <p><a href=\"#\" (click)=\"showItem($event, item.postSlug)\">Read More</a></p>\n</div>\n<div *ngIf=\"errorMsg\">\n    <p>Error: {{errorMsg}}</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/blog/blog-home.component.html
// module id = ./src/app/blog/blog-home.component.html
// module chunks = main